/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DocumentV1Dto } from './DocumentV1Dto';
import type { InitiateSignatureResponseV1Dto } from './InitiateSignatureResponseV1Dto';
export type YouSignSignatureWithRequestResponseV1Dto = {
  /**
   * The unique identifier of the entity.
   */
  readonly id: string;
  /**
   * The date when the entity was created.
   */
  readonly createdAt: string;
  /**
   * The date when the entity was modified.
   */
  readonly modifiedAt: string;
  /**
   * The current version of the entity
   */
  version: number;
  /**
   * Customer ID
   */
  customerId: string | null;
  /**
   * The related document dto
   */
  documents: Array<DocumentV1Dto> | null;
  /**
   * Request signature name
   */
  name: string;
  /**
   * Signature request ID
   */
  signatureRequestId: string | null;
  /**
   * Signature request status
   */
  status: YouSignSignatureWithRequestResponseV1Dto.status;
  /**
   * The related you-sign signature request
   */
  youSignSignatureRequest: InitiateSignatureResponseV1Dto;
};
export namespace YouSignSignatureWithRequestResponseV1Dto {
  /**
   * Signature request status
   */
  export enum status {
    APPROVAL = 'approval',
    CANCELED = 'canceled',
    DECLINED = 'declined',
    DELETED = 'deleted',
    DONE = 'done',
    DRAFT = 'draft',
    EXPIRED = 'expired',
    INITIATED = 'initiated',
    ONGOING = 'ongoing',
    REJECTED = 'rejected',
  }
}
